import styledComponents, { ThemedBaseStyledInterface } from 'styled-components'
import { TDefaultTheme } from './default-theme'

export const styled: ThemedBaseStyledInterface<TDefaultTheme> = styledComponents
